import moment from 'moment';
import { SERVER_DATE_FORMAT } from '../constants';

export default function preDefinedTimePeriodToDate(days) {
  return moment().subtract(days, 'd').format(SERVER_DATE_FORMAT);
}
